import { useState } from 'react'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { MdRateReview } from 'react-icons/md'
import ReusableModal from '../../../shared/ReuseableModal'
import CustomButton from '../../../shared/CustomButton'
import { Skeleton } from 'primereact/skeleton'

const RemarkModal = ({
  isVisible,
  onClose,
  title,
  HeaderIcon = MdRateReview,
  confirmLabel,
  buttonType = 'success',
  onConfirm,
  remarkRequired = true,
  loading = false,
  contextText = '',
  children = null,
  showRemark = true,
  confirmIcon = null,
  className = 'w-[95vw] md:w-[560px]',
  position = 'top'
}) => {
  const { t } = useTranslation()
  const [remark, setRemark] = useState('')

  const resetState = () => {
    setRemark('')
  }

  const handleClose = () => {
    if (loading) return
    resetState()
    onClose?.()
  }

  const handleConfirm = () => {
    if (showRemark && remarkRequired && !remark.trim()) {
      toast.error(t('Please enter a reason'))
      return
    }
    onConfirm?.(remark.trim())
  }

  return (
    <ReusableModal
      isVisible={isVisible}
      onClose={handleClose}
      title={title}
      HeaderIcon={HeaderIcon}
      className={className}
      position={position}
    >
      {loading ? (
        <div className='space-y-3 py-2'>
          <Skeleton width='100%' height='20px' />
          <Skeleton width='100%' height='70px' />
          <Skeleton width='100%' height='32px' />
        </div>
      ) : (
        <div className='space-y-3'>
          {children}

          {!!contextText && (
            <div className='rounded-md border border-blue-100 bg-blue-50 px-3 py-2 text-sm text-blue-900'>
              {contextText}
            </div>
          )}

          {showRemark && (
            <div>
              <label className='input-label'>{t('Remark')}</label>
              <textarea
                value={remark}
                onChange={event => setRemark(event.target.value)}
                placeholder={t('Enter remarks')}
                className='min-h-[96px] w-full rounded-md border border-gray-300 px-3 py-2 text-sm'
              />
            </div>
          )}

          <div className='flex justify-end gap-2 pt-2'>
            <CustomButton
              label={t('Cancel')}
              buttonType='reset'
              onClick={handleClose}
              disabled={loading}
            />
            <CustomButton
              label={confirmLabel || t('Confirm')}
              buttonType={buttonType}
              icon={confirmIcon}
              onClick={handleConfirm}
              loading={loading}
            />
          </div>
        </div>
      )}
    </ReusableModal>
  )
}

export default RemarkModal
